import React from 'react';
import {Link} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBroadcastTower} from '@fortawesome/free-solid-svg-icons';

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';

import AdminLayout from 'Pages/Admin/AdminLayout';

import SessionsApi from 'Services/Api/Admin/MainStage/Sessions';
import {Toast} from 'Services';

import {StartSession, EndSession, SwitchStream} from './Modals';

export default class MainStage extends React.Component {
    /**
     * @var state
     */
    state = {
        columns: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        this.setColumns();
    }

    /**
     * @method setColumns
     */
    setColumns = () => {
        let columns = [
            {
                label: 'Title',
                value: (record) => (
                    <>
                        {record.live && (
                            <FontAwesomeIcon icon={faBroadcastTower} className="mr-2 text-green-500" />
                        )}
                        {record.title}
                    </>
                ),
                type: 'callback',
                orderable: false,
            },
            {
                label: 'Stream SRC',
                value: 'stream_src',
                type: 'string',
                orderable: false,
            },
            {
                label: 'Starts At',
                value: 'starts_at',
                type: 'datetime',
                orderable: true,
            },
            {
                label: 'Ends At',
                value: 'ends_at',
                type: 'datetime',
                orderable: true,
            },
        ];

        if (Object.keys(window.base.languages).length > 1) {
            columns.push({
                label: 'Supported Languages',
                value: (record) => record.supported_languages && record.supported_languages.map((language, key) => {
                    let string = window.base.languages[language];

                    if (key !== (session.supported_languages.length - 1)) {
                        string += ', ';
                    }

                    return string;
                }),
                type: 'callback',
                orderable: false,
            });
        }

        this.setState({
            columns
        });
    }

    /**
     * @method getRowActions
     * @param {object} session
     */
    getRowActions = (session) => {
        let buttons = [
            {
                type: "link",
                to: "/admin/main-stage/store/"+session.id,
                text: "Edit"
            },
            {
                type: "modalTrigger",
                component: SwitchStream,
                props: {
                    session
                },
                text: `Switch To ${session?.stream_src === 'primary' ? 'Secondary' : 'Primary'} Stream`,
            }
        ];

        if (!session.live) {
            buttons.push({
                type: "modalTrigger",
                component: StartSession,
                props: {
                    session
                },
                text: 'Start'
            });
        }

        if (session.live) {
            buttons.push({
                type: "modalTrigger",
                component: EndSession,
                props: {
                    session
                },
                text: 'End'
            });
        }

        if (session.chat) {
            buttons.push({
                type: "link",
                to: "/admin/main-stage/chat/"+session.id,
                text: "Chat"
            });
        }

        if (session.reactions) {
            buttons.push({
                type: "link",
                to: "/admin/main-stage/reactions/"+session.id,
                text: "Reactions"
            });
        }

        if (session.questions) {
            buttons.push({
                type: "link",
                to: "/admin/main-stage/questions/"+session.id,
                text: "Questions"
            });
        }

        if (session.polls_enabled) {
            buttons.push({
                type: "link",
                to: "/admin/main-stage/polls/"+session.id,
                text: "Polls"
            });
        }

        buttons.push({
            type: "modalTrigger",
            component: Delete,
            props: {
                itemName: 'session',
                itemId: session.id,
                onDeleteApi: SessionsApi.delete
            },
            text: 'Delete'
        });

        return buttons;
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {columns} = this.state;

        return (
            <AdminLayout title="Main Stage">
                {columns &&
                    <IndexTable
                        columns={columns}
                        displaySearchBar={false}
                        storeLink="/admin/main-stage/store"
                        loadDataCallback={(data) => SessionsApi.get(null, data)}
                        rowActions={this.getRowActions}
                        eventApi={SessionsApi}
                    />
                }
            </AdminLayout>
        );
    }
}
